"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrivingLicenceNotFoundAlertWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var DrivingLicenceNotFoundAlertWidget = /** @class */ (function (_super) {
    __extends(DrivingLicenceNotFoundAlertWidget, _super);
    function DrivingLicenceNotFoundAlertWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.PARTIAL_DLN_INPUT_ID = "PartialDlnInputWidget";
        _this.scrollToElement = function () {
            var element = document.getElementById(_this.PARTIAL_DLN_INPUT_ID);
            if (!element) {
                throw new Error("Element with id '".concat(_this.PARTIAL_DLN_INPUT_ID, "' not found!"));
            }
            var mobile = 200;
            var desktop = 160;
            var scrollOffset = window.innerWidth > 450 ? desktop : mobile;
            scrollTo(0, element.getBoundingClientRect().top + window.scrollY - scrollOffset);
        };
        return _this;
    }
    DrivingLicenceNotFoundAlertWidget.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "page-validation journey-validation-summary", role: "alert", children: [(0, jsx_runtime_1.jsx)("div", { className: "page-validation-alert", children: (0, jsx_runtime_1.jsx)("img", { className: "page-validation-alert-icon", alt: "Alert icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/alert-red.svg") }) }), (0, jsx_runtime_1.jsxs)("div", { className: "page-validation-message", children: [(0, jsx_runtime_1.jsx)("p", { className: "page-validation-message-top margin-bottom-16", children: "There's a problem with the information you have provided. We were unable to find your driving licence number." }), (0, jsx_runtime_1.jsx)("div", { className: "page-validation-message-bottom", children: (0, jsx_runtime_1.jsx)("div", { className: "navigate-to-issue", children: (0, jsx_runtime_1.jsx)("button", { className: "hyperlink btn-text", onClick: function () { return _this.scrollToElement(); }, children: "Enter a valid driving licence number" }) }) })] })] }));
    };
    return DrivingLicenceNotFoundAlertWidget;
}(plugin_journey_1.WidgetBase));
exports.DrivingLicenceNotFoundAlertWidget = DrivingLicenceNotFoundAlertWidget;
//# sourceMappingURL=DrivingLicenceNotFoundAlertWidget.js.map